import
http
    // { httpmock }
    from "./../shared/axios";
import { Lead_Retrieve } from "../shared/ServiceCommonEndpoints";
class RetrieveService {
    funcRetrieveApp(payload) {
        const retrieve = {
            data: {
                ...payload
            },
            action: "RetrieveHSToken",
            type: "Swift App"
        }
        return http.post(Lead_Retrieve, retrieve, {
            headers: {
                "IDENTIFIER_1": localStorage.getItem("visitorID"),
                "IDENTIFIER_2": payload.hsToken
            }
        });
        // return httpmock.post("newcard-lead-retrieve", retrieve);
    }
}
// eslint-disable-next-line
export default new RetrieveService();
